// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileScreen_wrapper__X2dQE","center":"MobileScreen_center__UQf+6","title":"MobileScreen_title__cqcz6","text":"MobileScreen_text__DW+EE"};